export default __webpack_public_path__ + "static/media/device-good.727aece3.svg";